import React from 'react';
import { $DropBox } from './styles';
import { useDropContainer } from './';
export const DropBox = ({ children, type, onDrop, onClick, ...rest }) => {
    const [{ isOver, canDrop }, drop] = useDropContainer(type, { dropCallback: onDrop });
    return (React.createElement($DropBox, { clickable: !!onClick, onClick: onClick, className: 'DropBox', ref: drop, canDrop: canDrop, isOver: isOver, ...rest }, children));
};
